var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertOctIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#alert-oct-icon_svg__clip0_6168_22763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.696 1.234c.086-.086.13-.13.18-.16a.5.5 0 01.144-.06C4.078 1 4.14 1 4.261 1H7.74c.122 0 .183 0 .24.014a.5.5 0 01.145.06c.05.03.094.074.18.16l2.462 2.462c.086.086.13.13.16.18a.502.502 0 01.06.144c.014.058.014.119.014.241V7.74c0 .122 0 .183-.014.24a.502.502 0 01-.06.145c-.03.05-.074.094-.16.18l-2.462 2.462c-.086.086-.13.13-.18.16a.499.499 0 01-.144.06C7.922 11 7.86 11 7.739 11H4.26c-.122 0-.183 0-.24-.014a.499.499 0 01-.145-.06 1.073 1.073 0 01-.18-.16L1.234 8.304c-.086-.086-.13-.13-.16-.18a.5.5 0 01-.06-.144C1 7.922 1 7.86 1 7.739V4.26c0-.122 0-.183.014-.24a.5.5 0 01.06-.145c.03-.05.074-.094.16-.18l2.462-2.462z",
    fill: "#9E6E00",
    stroke: "#9E6E00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3.55a.45.45 0 01.45.45v2a.45.45 0 01-.9 0V4A.45.45 0 016 3.55zM5.55 8A.45.45 0 016 7.55h.006a.45.45 0 110 .9H6A.45.45 0 015.55 8z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "alert-oct-icon_svg__clip0_6168_22763"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
}
export default SvgAlertOctIcon;